import * as React from "react";
import styled from "styled-components";

export default function SectionHeader({ title, subtitle }) {
  return (
    <HeaderContainer role="banner" aria-labelledby="main-title subtitle-heading">
      <MainTitle id="main-title" aria-level={1} role="heading">
        {title}
      </MainTitle>
      <SubTitle id="subtitle-heading" aria-level={2} role="heading">
        {subtitle}
      </SubTitle>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header`
  display: flex;
  width: 100%;
  max-width: 691px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  position: relative;
`;

const MainTitle = styled.h1`
  align-self: stretch;
  color: #1c1b1f;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
  position: relative;
  font: 700 16px/120% Inter, sans-serif;
  margin: 0;
`;

const SubTitle = styled.h1`
  width: 100%;
  color: #1c1b1f;
  text-align: center;
  letter-spacing: -0.48px;
  position: relative;
  font: 700 48px/120% Inter, sans-serif;
  margin: 0;

  @media (max-width: 991px) { 
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 640px) {
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.28px;
  }
`;